import React, {Component} from 'react'
import Cleave from 'cleave.js/react';

class CustomNomenclatureInput extends Component {

    constructor(props){
        super(props);
        this.onChangeHandler = this.onChangeHandler.bind(this);
    }

    onChangeHandler(event){
        this.props.onChange(event.target.rawValue);
    }

    render() {
        return (
            <div>
                <Cleave className={this.props.className} placeholder={this.props.placeholder} onChange={this.onChangeHandler} options={{delimiter: '-', numericOnly: true, blocks: [2,2,2,4,6]}} />
            </div>
        );
    }
}

export default CustomNomenclatureInput


/** WEBPACK FOOTER **
 ** ./src/components/CustomNomenclatureInput.js
 **/